/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkExecutionStatusDto
 */
export interface BulkExecutionStatusDto {
    /**
     * 
     * @type {boolean}
     * @memberof BulkExecutionStatusDto
     */
    isRunning?: boolean;
}

/**
 * Check if a given object implements the BulkExecutionStatusDto interface.
 */
export function instanceOfBulkExecutionStatusDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BulkExecutionStatusDtoFromJSON(json: any): BulkExecutionStatusDto {
    return BulkExecutionStatusDtoFromJSONTyped(json, false);
}

export function BulkExecutionStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkExecutionStatusDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isRunning': !exists(json, 'isRunning') ? undefined : json['isRunning'],
    };
}

export function BulkExecutionStatusDtoToJSON(value?: BulkExecutionStatusDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isRunning': value.isRunning,
    };
}

